import React, {useEffect, useState} from 'react';
import {requestGetJobOtherInfo, requestGetJobRequirementInfo} from "@app/services/JobService";
import {callApiSaveJob} from "@pages/job/common/Services";
import {CandidateDetailLanguageMode} from "@app/constants/Tabs";
import AllUserInputField from "@pages/candidate/commonview/AllUserInputField";
import {requestGetEmployer} from "@app/services/EmployerService";

const JobOtherContent = (props) => {
    const [job, setJob] = useState({input_job_other: {}});
    const [employer, setEmployer] = useState({});

    const {jobInput, mode, employerId, onChange} = props

    const fetchJobOtherInfo = async (jobId) => {
        if (jobId) {
            const res = await requestGetJobOtherInfo({job_id: jobId})
            const changeJob = {...jobInput}
            changeJob.job_id = jobId
            changeJob.input_job_other = res.content
            setJob(changeJob)
        }
    };

    useEffect(async () => {
        if (jobInput && mode !== CandidateDetailLanguageMode.SEARCH) {
            if (!jobInput.input_job_other) {
                jobInput.input_job_other = {}
            }
            setJob(jobInput)

            if (jobInput.id) {
                await fetchJobOtherInfo(jobInput.id)
            }
        }
    }, [jobInput]);

    const fetchEmployer = async (id) => {
        const res = await requestGetEmployer({employer_id: id});
        const emp = res.content
        if (emp) {
            setEmployer(emp)

            if (!job.id) {
                job.input_job_other.working_time_to_send = emp.working_time_to_send
                job.input_job_other.about_employer_to_send = emp.about_employer_to_send
                setJob({...job})
                if (onChange) {
                    onChange(job)
                }
            }
        }
    };

    useEffect(async () => {
        if (employerId) {
            fetchEmployer(employerId)
        }
    }, [employerId]);

    const onChangeJobOtherInfo = (fieldName, value) => {
        job.input_job_other[fieldName] = value
        setJob({...job})
        if (onChange) {
            onChange(job)
        }
    };

    const onSave= () => {
        callApiSaveJob(job, (res) => {
            const newJob = res.content
            job.id = newJob.id
            setJob({...job})
        })
    }

    const defaultWorkingTimeToSend = () => {

    }

    return (
        <div className='card card-default'>
            <div className='card-header'>
                <h3 className='card-title text-bold'>Others</h3>
                <div className='card-tools'>
                    {mode !== CandidateDetailLanguageMode.SEARCH &&
                    <button type='button' className='btn btn-primary'
                            onClick={() => onSave()}>Save
                    </button>
                    }
                </div>
            </div>
            <div className='card-body'>
                <div className='input-group mt-3'>
                    <label className={'w-100'}>Thời gian LV (to send)</label>
                    <div style={{width: '100%'}}>
                        <textarea className='form-control'
                                  value={job.input_job_other.working_time_to_send ?
                                      job.input_job_other.working_time_to_send : ''}
                                  name={'working_time_to_send'}
                                  onChange={event => onChangeJobOtherInfo("working_time_to_send", event.target.value)}/>
                        <AllUserInputField arrInfo={job.input_job_other.all_other_user_input} field='working_time_to_send' canDelete={false}/>
                    </div>
                </div>
                <div className='input-group mt-3'>
                    <label className={'w-100'}>Thông tin về Employer (to send)</label>
                    <div style={{width: '100%'}}>
                        <textarea className='form-control'
                                  value={job.input_job_other.about_employer_to_send ?
                                      job.input_job_other.about_employer_to_send : ''}
                                  name={'about_employer_to_send'}
                                  onChange={event => onChangeJobOtherInfo("about_employer_to_send", event.target.value)}/>
                        <AllUserInputField arrInfo={job.input_job_other.all_other_user_input} field='about_employer_to_send' canDelete={false}/>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default JobOtherContent;
